import plusIcon from '@iconify/icons-ant-design/plus-outline';
import { InvisibleButton } from '@/widgets/components/invisible-button';
import React from 'react';
import { cssVars } from '@/app/styles';
import { IconGeneric } from '@/widgets/components/icon';
import styled from 'styled-components';
import { HeaderMd } from './header-md';

export const CardTemplate = styled.div`
  border-radius: 10px;
  box-shadow:
    0 2px 3px 0 rgba(8, 10, 37, 0.03),
    0 4px 8.5px 0 rgba(8, 10, 37, 0.05),
    0 7.5px 35px 0 rgba(89, 126, 247, 0.03);
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
`;

/**
 * Large card component
 */
export const Lg = styled(CardTemplate)`
  width: 810px;
  height: ${cssVars.standardCardHeight};
  padding: ${cssVars.cardPad};
  padding-bottom: 27px;
`;

/**
 * Small card component
 */
export const Sm = styled.div`
  margin: 21px;
  width: 380px;
  height: 360px;
  border-radius: 10px;
  box-shadow:
    0 2px 40px 0 rgba(184, 195, 212, 0.4),
    0 0 10px 0 rgba(54, 65, 110, 0.1);
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  position: relative; /* this is so in order to allow absolutely positioned button in top-right */
  justify-content: space-between;
  cursor: pointer;
`;

const AddChartCardButton = styled(InvisibleButton)`
  padding: 0;
  height: 100%;
  width: 100%;
  /* position: absolute; */
`;

export const CardLgContentWrapper = styled.div`
  margin-left: ${cssVars.cardLgMarginLR};
  margin-right: ${cssVars.cardLgMarginLR};
`;

export const StyledMd = styled(CardTemplate)`
  height: ${cssVars.standardCardHeight};
  width: ${cssVars.standardCardHeight};
  padding-top: 26px;
  padding-left: 26px;
  padding-right: 26px;
  padding-bottom: 24px;
  box-shadow: ${(props) =>
    props.boxShadowOverride
      ? 'unset'
      : '0 2px 3px 0 rgba(8, 10, 37, 0.03), 0 4px 8.5px 0 rgba(8, 10, 37, 0.05), 0 7.5px 35px 0 rgba(89, 126, 247, 0.03)'};
  /* Cursor shows hand pointer if it opens a modal, else show default arrow */
  cursor: ${(props) => (props.clickable ? 'pointer' : 'default')};
  /* Catch any transitions and ease in out*/
  transition: all 0.3s ease-in-out;
  /* On hover shrinks the cards if they are growable (opens a modal)*/
  &:hover {
    transform: ${(props) => (props.growable ? 'scale(.95)' : '')};
  }
`;

export const StyledAddChartMd = styled(StyledMd)`
  background-color: rgba(89, 126, 247, 0.15);
  border-width: 2px;
  border-style: dashed;
  border-color: #c7d1f3;
  padding: 0;
`;

const GiantPlus = styled(IconGeneric)`
  color: ${cssVars.color.rentalscapeBlue};
`;

const StyledAddChartText = styled.div`
  font-size: 14px;
  color: ${cssVars.color.rentalscapeBlue};
  ::before {
    content: 'Add chart';
  }
`;

const PlusIconWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

// --------------------------------------------------------

/**
 * Medium sized card
 *
 * @param {string} props.title title in card header
 * @param {*} children this will be the actual card content
 */
export function Md(props) {
  const {
    children,
    title,
    onClick, // this is actually chart onClick,
    onClickHandlers,
    optionsClick,
    optionItems,
    onHide,
    growable,
    clickable,
    boxShadowOverride,
    optionsOverride,
  } = props;
  // Here we have to make StyledMd (which is a div) act as a button with an onClick event
  // ..because we are not allowed to have nested buttons. Cards will have buttons as children
  return (
    <StyledMd
      growable={growable}
      boxShadowOverride={boxShadowOverride}
      clickable={clickable}
      onClick={() => onClickHandlers.expand()}
    >
      <HeaderMd
        title={title}
        optionsClick={optionsClick}
        optionItems={optionItems}
        onClickHandlers={{ ...onClickHandlers, expand: onClick, hide: onHide }}
        onHide={onHide}
        optionsOverride={optionsOverride}
      />
      {children}
    </StyledMd>
  );
}

export function AddChartCard(props) {
  return (
    <StyledAddChartMd growable clickable>
      <AddChartCardButton onClick={() => props.onClick()}>
        <PlusIconWrapper>
          <GiantPlus size={'60px'} icon={plusIcon} />
          <StyledAddChartText />
        </PlusIconWrapper>
      </AddChartCardButton>
    </StyledAddChartMd>
  );
}
